export default class ViewportWidthUtil {
  constructor () {
    this._updateProperty = this._updateProperty.bind(this);

    this._updateProperty();

    window.addEventListener('resize', this._updateProperty);
  }

  _updateProperty () {
    const width = document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--dgfm-viewport-width', `${width}px`);
  }
}